/*
 * Carousels
 */

import slick from "slick-carousel";

export default function() {
  document.addEventListener("DOMContentLoaded", function() {
    if (!document.body.classList.contains("sfPageEditor")) {
      var options = {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-prev slick-arrow fmi-icon fmi-icon-arrow-left"></button>',
        nextArrow:
          '<button type="button" class="slick-next slick-arrow fmi-icon fmi-icon-arrow-right"></button>',
        onAfterChange: function(slick, currentSlide) {},
      };
      if (window.matchMedia("(max-width: 767px)").matches) {
        options.slidesToScroll = 1;
        options.slidesToShow = 1;
      }

      Array.from(document.querySelectorAll(".home-speaker-carousel")).forEach(
        (carousel) => {
          if (
            carousel.parentElement.classList.contains(
              "speaker-content-container-stack"
            )
          ) {
            // Custom options for speaker content carousel
            var speakerOptions = {
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              prevArrow:
                '<button type="button" class="slick-prev slick-arrow fmi-icon fmi-icon-arrow-left"></button>',
              nextArrow:
                '<button type="button" class="slick-next slick-arrow fmi-icon fmi-icon-arrow-right"></button>',
            };

            // Responsive settings
            if (window.matchMedia("(max-width: 767px)").matches) {
              speakerOptions.slidesToShow = 1;
              speakerOptions.slidesToScroll = 1;
            }
            $(
              ".home-speaker-carousel-container.speaker-content-container-stack"
            ).on("init", function(event, slick) {
              const currentSlideElement = slick.$slides.eq(0);
              const speakerContent = currentSlideElement.find(
                ".speaker-content"
              );
              if (speakerContent.length > 0) {
                // Clear existing content in the stack
                const contentStack = document.querySelector(
                  ".speaker-content-stack"
                );
                if (contentStack) {
                  contentStack.innerHTML = "";

                  // Append only the contents of the speaker content to the stack
                  contentStack.innerHTML = speakerContent.html();
                }
              }
            });
            $(
              ".home-speaker-carousel-container.speaker-content-container-stack"
            ).on("afterChange", function(
              event,
              slick,
              currentSlide,
              nextSlide
            ) {
              // Get the current slide's speaker content
              const currentSlideElement = slick.$slides.eq(currentSlide);
              const speakerContent = currentSlideElement.find(
                ".speaker-content"
              );

              if (speakerContent.length > 0) {
                // Clear existing content in the stack
                const contentStack = document.querySelector(
                  ".speaker-content-stack"
                );
                if (contentStack) {
                  contentStack.innerHTML = "";

                  // Append only the contents of the speaker content to the stack
                  contentStack.innerHTML = speakerContent.html();
                }
              }
            });

            $(carousel).slick(speakerOptions);
          } else {
            // Use default options for other carousels
            $(carousel).slick(options);
          }

          // Move arrow controls
          const prevArrow = carousel.parentElement.querySelector(
            ".slick-prev.slick-arrow.fmi-icon.fmi-icon-arrow-left"
          );
          const nextArrow = carousel.parentElement.querySelector(
            ".slick-next.slick-arrow.fmi-icon.fmi-icon-arrow-right"
          );
          const controls = carousel.parentElement.querySelector(
            ".home-speaker-controls"
          );

          if (prevArrow && controls) {
            controls.appendChild(prevArrow);
          }
          if (nextArrow && controls) {
            controls.appendChild(nextArrow);
          }
        }
      );
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/partials/carousel.js